import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PostCard, StateBlock } from "../components/Cards";
import { useAuth } from "../lib/auth";
import { getFeedPosts, getTopPosts, getUser } from "../lib/data";
import { setSeo } from "../lib/seo";
import { useAsync } from "../lib/useAsync";

export function Feed() {
  const { user } = useAuth();
  const { data: profile, loading: profileLoading, error: profileError } = useAsync(
    () => (user ? getUser(user.uid) : Promise.resolve(null)),
    [user?.uid]
  );
  const { data, loading, error } = useAsync(async () => {
    if (!profile?.following?.length) return [];
    const [topPosts, posts] = await Promise.all([getTopPosts(), getFeedPosts()]);
    const followingIds = new Set(profile.following);
    const blockedIds = new Set(profile.blockedUsers || []);
    return [
      ...topPosts.map((post) => ({ post, collectionName: "topPosts" })),
      ...posts.map((post) => ({ post, collectionName: "posts" }))
    ].filter(({ post }) => followingIds.has(post.authorId) && !blockedIds.has(post.authorId));
  }, [profile?.following?.join("|"), profile?.blockedUsers?.join("|")]);

  useEffect(() => {
    setSeo({
      title: "Feeds | My Local Forum",
      description: "Read the latest approved local forum posts and top posts.",
      path: "/feed"
    });
  }, []);

  return (
    <section className="page">
      <h1>Feeds</h1>
      {!user ? <Link className="primary-button" to="/auth">Sign in to view followed-user posts</Link> : null}
      <StateBlock loading={profileLoading || loading} error={profileError || error} empty={Boolean(user) && data?.length === 0} />
      <div className="masonry">
        {data?.map(({ post, collectionName }) => (
          <PostCard key={`${collectionName}:${post.id}`} post={post} collectionName={collectionName} />
        ))}
      </div>
    </section>
  );
}
